import { http } from '@/http/axios.js';

export function getListAPI() {
  return http({
    url: '/adminapi/oprt/doc/list',
    method: 'get'
  })
}
// 详情
export function getDetailAPI(docCode) {
  return http({
    url: '/adminapi/oprt/doc/detail',
    method: 'get',
    params: { docCode }
  })
}
// 编辑
export function handleSaveAPI(data) {
  return http({
    url: '/adminapi/oprt/doc/save',
    method: 'post',
    data
  })
}
